const GENERAL_SETTING_LOADING = "GENERAL_SETTING_LOADING";
const GENERAL_SETTING_ERROR = "GENERAL_SETTING_ERROR";
const GENERAL_SETTING_SUCCESS = "GENERAL_SETTING_SUCCESS";
export { GENERAL_SETTING_LOADING, GENERAL_SETTING_ERROR, GENERAL_SETTING_SUCCESS };